export default "__VITE_ASSET__DFqNq36Y__"